import {PerformanceLogger} from '../performance';
import {ENVIRONMENT_LEVEL} from '@/Constant';

export class EditorFile {

    key = 'EditorFile';

    logger: PerformanceLogger;

    constructor(logger: PerformanceLogger) {
        this.logger = logger;
    }

    logWeb =({id, data}: {id: string, data?: any}) => {
        try {
            const logger = this.logger;
            const logLevel = logger?.logLevel || '';
            if ([ENVIRONMENT_LEVEL.online, ENVIRONMENT_LEVEL.gray, ENVIRONMENT_LEVEL.qa].includes(logLevel)) {
                const opVersion = logger?.getOpVersionInfo();
                logger.feLogger({
                    id,
                    data: {
                        ...data,
                        opVersion,
                    },
                });
            }
        } catch (e) {
            console.error(e);
        }
    };

    uploadStart() {
        this.logWeb({
            id: '80001.2.25',
        });
    }

    uploadSuccess() {
        this.logWeb({
            id: '80001.2.26',
        });
    }

    uploadFail(e: any) {
        this.logWeb({
            id: '80001.2.27',
            data: e,
        });
    }

    downloadStart() {
        this.logWeb({
            id: '80001.2.28',
        });
    }

    downloadSuccess() {
        this.logWeb({
            id: '80001.2.29',
        });
    }

    downloadError(e: any) {
        this.logWeb({
            id: '80001.2.30',
            data: e,
        });
    }


}
